import React from 'react'

export default function Tags (props) {
    return(
        <div className='w-[8.8rem] px-3 py-3 border-[1px] border-[#E5E7EB] rounded-[12px] bg-white'>
            <div className='flex items-end justify-end'>
                <img src={props.closeicon} />
            </div>
            <div className='flex items-center flex-col justify-center gap-2 '>
                <img className='w-[2rem]' src={props.tagsimg} />
                <p className='text-[0.70rem] text-[#6B7280] text-center'>{props.tagstext}</p>
            </div>
        </div>
    );
}